import "./bootstrap";
import "./datatable";
import "./api";
import "./notification";
import "./select2";
import "./popup";
import "./copy";
import "./customers";
import "./menu";
import "./modal";
import "./files";

import("./map").then(() => {
    // console.log("Map module loaded dynamically.");
});

import { toggleSort, toggleCustomSort } from "./datatable/helpers/sorting";
import { Livewire } from "../../vendor/livewire/livewire/dist/livewire.esm";

window.toggleSort = toggleSort;
window.toggleCustomSort = toggleCustomSort;

// Load onboarding scripts before Livewire starts but after Livewire is imported
import "./onboarding";

Livewire.start();

// Show release notes modal if the URL contains the query parameter 'openModal=release_notes_modal'
document.addEventListener("DOMContentLoaded", function () {
    const urlParams = new URLSearchParams(window.location.search);
    const openModal = urlParams.get("openModal");

    if (openModal === "release_notes_modal") {
        const modalElement = document.querySelector("#release_notes_modal");
        if (modalElement) {
            modalElement.classList.remove("hidden");
        }
    }
});

import "./menu-scroll";